/**
 * ATTENTION: This file is auto generated by using "prepareTemplates".
 * Do not change the content!
 *
 */

/**
 * Library Index template to autogenerate all the fragments and extensions
 * Used by "prepareTemplates"
 */

// import all the available fragments
import DrawerList from './drawer-list/DrawerList'
import ScrollView from './scroll-view/ScrollView'
import TextCounter from './text-counter/TextCounter'

// define / export all the available fragments
export { DrawerList, ScrollView, TextCounter }

export const getFragments = () => {
  return { DrawerList, ScrollView, TextCounter }
}
